import { render, staticRenderFns } from "./May28.vue?vue&type=template&id=622803fa&scoped=true&"
import script from "./May28.vue?vue&type=script&lang=js&"
export * from "./May28.vue?vue&type=script&lang=js&"
import style0 from "./May28.vue?vue&type=style&index=0&id=622803fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622803fa",
  null
  
)

export default component.exports